import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Home, Phone, Menu, X } from 'lucide-react';

interface HeaderProps {
  onLoginClick?: () => void;
}

export function Header({ onLoginClick }: HeaderProps) {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <motion.header
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      className="fixed top-0 left-0 right-0 bg-white/80 backdrop-blur-md z-50 border-b border-gray-100"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <motion.div
              className="text-xl font-bold text-brand-600 flex items-center gap-2"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <Link to="/">Hubbery - The Conversation Hub</Link>
            </motion.div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-6">
            <Link 
              to="/" 
              className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-1"
            >
              <Home size={16} />
              Home
            </Link>
            <Link 
              to="/functies" 
              className="text-gray-600 hover:text-gray-900 transition-colors"
            >
              Functies
            </Link>
            <Link 
              to="/voordelen" 
              className="text-gray-600 hover:text-gray-900 transition-colors"
            >
              Voordelen
            </Link>
            <Link 
              to="/prijzen" 
              className="text-gray-600 hover:text-gray-900 transition-colors"
            >
              Prijzen
            </Link>
          <Link
            to="/contact"
            className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-1"
          >
            <Phone size={16} />
            Contact
          </Link>
          <button
            onClick={onLoginClick}
            className="text-gray-600 hover:text-gray-900 transition-colors"
          >
            Login
          </button>
        </nav>

          {/* Desktop Navigation Placeholder */}

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 text-gray-600 hover:text-gray-900"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden bg-white border-t border-gray-100"
          >
            <div className="px-4 py-4 space-y-4">
              <Link 
                to="/"
                className="block py-2 text-gray-600 hover:text-gray-900 transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Home
              </Link>
              <Link 
                to="/functies"
                className="block py-2 text-gray-600 hover:text-gray-900 transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Functies
              </Link>
              <Link 
                to="/voordelen"
                className="block py-2 text-gray-600 hover:text-gray-900 transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Voordelen
              </Link>
              <Link 
                to="/prijzen"
                className="block py-2 text-gray-600 hover:text-gray-900 transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Prijzen
              </Link>
              <Link
                to="/contact"
                className="block py-2 text-gray-600 hover:text-gray-900 transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Contact
              </Link>
              <button
                onClick={() => {
                  setIsMenuOpen(false);
                  onLoginClick?.();
                }}
                className="block py-2 text-gray-600 hover:text-gray-900 transition-colors"
              >
                Login
              </button>

              {/* Mobile Navigation Placeholder */}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
}
